import { z } from 'zod';
import { MAINTENANCE_PLAN_IDS } from './maintenancePlans';

export const INQUIRY_SERVICES = [
  { value: 'other', label: 'Not sure / general question' },
  { value: 'pumping', label: 'Septic pumping' },
  { value: 'installation', label: 'Installation' },
  { value: 'inspection', label: 'Inspection' },
  { value: 'repairs', label: 'Repairs' },
  { value: 'design', label: 'System design' },
] as const;
const email = z.string().trim().max(320).refine(value => !value || z.string().email().safeParse(value).success, 'Enter a valid email address.').default('');
const phone = z.string().trim().max(20).refine(value => {
  if (!value) return true;
  const digits = value.replace(/\D/g, '');
  return /^[+()\d .-]+$/.test(value) && (digits.length === 10 || (digits.length === 11 && digits.startsWith('1')));
}, 'Enter a 10-digit US phone number.').default('');
export const inquiryInputSchema = z.object({
  name: z.string().trim().min(1, 'Enter your name.').max(100, 'Use 100 characters or fewer.').regex(/^[^<>\r\n]+$/, 'Please enter a plain-text name.'),
  email,
  phone,
  serviceType: z.string().trim().min(1, 'Choose a service.').max(100).regex(/^[^<>\r\n]+$/, 'Choose a valid service.'),
  zipCode: z.string().trim().max(10).refine(value => !value || /^\d{5}(?:-\d{4})?$/.test(value), 'Enter a valid ZIP code.').default(''),
  message: z.string().trim().min(10, 'Please include at least 10 characters about what you need.').max(2000, 'Use 2,000 characters or fewer.'),
  consent: z.literal(true, { message: 'Please allow us to contact you about this inquiry.' }),
  source: z.enum(['website_form', 'website_widget', 'maintenance_plan']).default('website_form'),
  maintenancePlan: z.enum(MAINTENANCE_PLAN_IDS).optional(),
  website: z.string().max(200).default(''), // Hidden honeypot; never stored.
}).superRefine((value, context) => {
  if (!value.email && !value.phone) context.addIssue({ code: 'custom', path: ['email'], message: 'Add a phone number or email so our team can reply.' });
  if (value.source === 'maintenance_plan' && !value.maintenancePlan) context.addIssue({ code: 'custom', path: ['maintenancePlan'], message: 'Choose a plan or ask us to recommend one.' });
  if (value.maintenancePlan && value.source !== 'maintenance_plan') context.addIssue({ code: 'custom', path: ['maintenancePlan'], message: 'Use the maintenance-plan request form for this selection.' });
});
export type InquiryInput = z.output<typeof inquiryInputSchema>;
